// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.radio-group-container[data-v-3499f260] {\r\n  max-height: 300px;\r\n  overflow:auto;\n}\n.van-cell-offset[data-v-3499f260] {\r\n  font-size: 16px;\r\n  line-height: 22px;\r\n  padding: 15px 17px;\r\n  color: #191919;\n}\r\n", ""]);
// Exports
module.exports = exports;
